import Close from './Close'

export default Close
// eslint-disable-next-line import/export
export * from './Close'
